import React from 'react';
import PropTypes from 'prop-types';

const WarningPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M3 16C3 8.832 8.831 3 16 3c7.168 0 13 5.832 13 13 0 7.169-5.832 13-13 13-7.169 0-13-5.831-13-13zm11.69 1.608c0 .65.587 1.178 1.31 1.178.728 0 1.31-.527 1.31-1.178l.82-8.513c.09-1.063-.804-1.916-1.995-1.916h-.269c-1.186 0-2.085.858-1.996 1.916l.82 8.513zm-.547 5.356c0 1.03.828 1.857 1.857 1.857a1.853 1.853 0 0 0 1.857-1.857A1.853 1.853 0 0 0 16 21.107a1.853 1.853 0 0 0-1.857 1.857z"
    />
  );
};

WarningPath.propTypes = {
  fill: PropTypes.string,
};

export default WarningPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/feedback/warning.jsx